import { axiosAiq } from 'config';

export const fetchFeatureFlag = async () => {
    const response = await axiosAiq.get('/feature-flag/all');
    const { data } = response;
    return data;
};
